/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs */

const en_register_onboarding_personal_info_add_practical_experience_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add practical experience`)
};

const de_register_onboarding_personal_info_add_practical_experience_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktische Erfahrung hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add practical experience" |
*
* @param {Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_add_practical_experience_button = /** @type {((inputs?: Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Add_Practical_Experience_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_add_practical_experience_button(inputs)
	return en_register_onboarding_personal_info_add_practical_experience_button(inputs)
});